/** @format */

import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertInfoFilled
} from '@dsg-tech/homefield-angular-icons';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';

interface ReturnPolicyMessage {
	returnPolicyName: string;
	returnPolicyContent: string;
	returnPolicyUrl: string;
}

@Component({
	selector: 'pdp-return-policy',
	templateUrl: './return-policy.component.html',
	styleUrl: './return-policy.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [HmfTextLinkComponent, HomefieldIconLibraryModule]
})
export class ReturnPolicyComponent {
	// Even though the data is static now, just using a signal
	readonly returnPolicyMessage = signal<ReturnPolicyMessage>({
		returnPolicyName: 'Bikes',
		returnPolicyContent:
			'Unused bikes are eligible for return up to 24 hours after in store purchase, pick-up, or home delivery.',
		returnPolicyUrl: '/s/return-policy'
	});

	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconAlertInfoFilled]);
	}
}
